import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { map } from 'rxjs/operators';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  constructor(
    private common: CommonService,
    private socket: Socket
  ) {

  }

  // /**
  //  * getSocket
  //  */
  // getSocket() {
  //   return this.socket.fromEvent('p67logistics_complete_user_rescue').pipe(map((data) => data));
  // }

  // /**
  //  * sendStatusRecue
  //  * @param status 
  //  * @param idUser 
  //  * @param supplierId 
  //  * @returns 
  //  */
  // sendStatusRecue(status: any, idUser: any, supplierId: any) {
  //   return this.socket.emit('p67logistics_complete_user_rescue', { "status": status, "userId": idUser, "supplierId": supplierId })
  // }
}
